import React from "react";
import TeamLogo from "./TeamLogo";

const plainPosition = { width: "1%", textAlign: "center" };
const white = { color: "white" };

// One team's line in a league table. The two teams in the match are highlighted
// in their colours, with white text (Team B's position stays the default colour).
const StandingRow = ({ item, rowStyle, positionStyle, textStyle }) => (
  <tr style={rowStyle}>
    <td style={positionStyle}>{item.position}.</td>
    <td className="hideForSmall" style={{ padding: "1px", width: "34px" }}>
      {item.team_image_id ? (
        <img
          alt={item.team_name}
          src={`https://4rsoccer6us.blob.core.windows.net/soccer-team-logos/${item.team_image_id}.png`}
          style={{ height: "32px" }}
        />
      ) : (
        <TeamLogo id={item.team_id} name={item.team_name} small={true} />
      )}
    </td>
    <td style={textStyle}>{item.team_name}</td>
    <td className="centertext" style={textStyle}>
      {item.played}
    </td>
    <td className="centertext" style={textStyle}>
      {item.won}
    </td>
    <td className="centertext" style={textStyle}>
      {item.drawn}
    </td>
    <td className="centertext" style={textStyle}>
      {item.lost}
    </td>
    <td className="hideForSmall centertext" style={textStyle}>
      {item.goals_for}
    </td>
    <td className="hideForSmall centertext" style={textStyle}>
      {item.goals_against}
    </td>
    <td className="centertext" style={textStyle}>
      {item.points}
    </td>
  </tr>
);

const TableRow = ({ item, previous, team_a_id, team_b_id }) => {
  return (
    <>
      {parseInt(item.position) > previous ? null : (
        <tr>
          <td>&nbsp;</td>
          <td class="hideForSmall">&nbsp;</td>
          <td>&nbsp;</td>
          <td>&nbsp;</td>
          <td>&nbsp;</td>
          <td>&nbsp;</td>
          <td>&nbsp;</td>
          <td class="hideForSmall">&nbsp;</td>
          <td class="hideForSmall">&nbsp;</td>
          <td>&nbsp;</td>
        </tr>
      )}
      {item.team_id !== team_a_id && item.team_id !== team_b_id ? <StandingRow item={item} positionStyle={plainPosition} /> : null}
      {item.team_id === team_a_id ? (
        <StandingRow item={item} rowStyle={{ backgroundColor: "seagreen" }} positionStyle={{ ...plainPosition, ...white }} textStyle={white} />
      ) : null}
      {item.team_id === team_b_id ? (
        <StandingRow item={item} rowStyle={{ backgroundColor: "royalblue" }} positionStyle={plainPosition} textStyle={white} />
      ) : null}
    </>
  );
};

export default TableRow;
